export enum ESubscriptionStatus {
  INITIATED = "initiated",
  ACTIVE = "active",
  CANCELLED = "cancelled",
  SESSION_CANCELLED = "session_cancelled",
  CHECKOUT_SESSION_EXPIRED = "checkout_session_expired",
}

export enum EPaymentStatus {
  PAID = "paid",
  FAILED = "failed",
}

export enum ESubscriptionProductCode {
  TRIAL = "trial",
  PRO = "pro",
  BUSINESS = "business",
  ENTERPRISE = "enterprise",
}

export enum ESubscriptionProductType {
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum ECurrency {
  USD = "USD",
  RUB = "RUB",
}

export interface ICost {
  price: number;
  currency: ECurrency;
}

export interface ISubscriptionPrice {
  type: ESubscriptionProductType;
  cost: ICost;
}

export interface ISubscription {
  name: string;
  code: ESubscriptionProductCode;
  priceList: ISubscriptionPrice[];
  disabled?: boolean;
}

export interface IBillingHistoryPayment {
  uuid: string;
  title: string | null;
  amountPaid: ICost;
  amountDue: ICost;
  paidAt: string | null;
  status: EPaymentStatus;
  invoicePdfUrl: string | null;
  invoicePeriodStart: string | null;
  invoicePeriodEnd: string | null;
  createdAt: string;
}

export interface IBillingHistory {
  uuid: string;
  name: string;
  cost: ICost;
  productCode: ESubscriptionProductCode;
  typeCode: ESubscriptionProductType;
  status: ESubscriptionStatus;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancellationReason: string | null;
  createdAt: string;
  canceledAt: string | null;
  updatedAt: string;
  payments: IBillingHistoryPayment[];
}

export interface IUpcomingPayment {
  amount: ICost;
  amountDue: ICost;
  nextPaymentAttempt: string;
  title: string | null;
  invoicePeriodStart: string;
  invoicePeriodEnd: string;
}

export interface ISubscriptionCheckoutPayload {
  productCode: ESubscriptionProductCode;
  productType: ESubscriptionProductType;
}

export interface ICancelSubscriptionPayload {
  reason: string;
}

export interface ISubscriptionBalanceResponse {
  balance: ICost;
}

export interface ISubscriptionCheckoutResponse {
  url: string | null;
}

export interface ISavedPaymentMethod {
  id: string;
  paymentMethodExternalId: string | null;
  paymentProvider: string;
  isDefault: boolean;
  createdAt: string;
}

export interface ISavePaymentMethodResponse {
  url: string | null;
}
